import { render, staticRenderFns } from "./SlidePublication.vue?vue&type=template&id=5fdb60c0&"
import script from "./SlidePublication.vue?vue&type=script&lang=js&"
export * from "./SlidePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports